import { Close } from '@mui/icons-material'
import { Autocomplete, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import './approvalDialog.css'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DatePicker from "react-datepicker";
import GetAllAccountTypeData from '../../Apis/GetAllAccountTypeData';
import { showToast } from '../../utils/toastUtils';
import EditUserConfiguration from '../../Apis/editUserConfiguration';
import getAccessRoles from '../../Apis/getAccessRoles';
import MyContext from '../../Context/AppContext';
import configJSON from '../../Config.json'

const ApprovalDialogBox = (props) => {

    const { open, handleClose, isEdit, userData, pendingRowAdjustment, setKendoDataLoading, handleApprovedUserRowChange, isUndoRejection, handleRevokeUserRowChange } = props
    const { userDetails } = useContext(MyContext);
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    const [accountTypeData, setAccountTypeData] = useState([])
    const [userConfigData, setUserConfigData] = useState({
        accountType: '',
        chatLimit: '',
        expiryDate: new Date(),
        accessRoleData: {},
        usageAccess: [],
    })
    const usageAccessOptions_admin = ["Create JD", "Check Usage", "Manage Users", "Approve Request", "Access Chat history"]
    const usageAccessOptions_user = ["Create JD", "Check Usage", "Access Chat history"]
    const [isDataLoading, setIsDataLoading] = useState(true)
    const [isDataUpdating, setIsDataUpdating] = useState(false)
    const [accessRoles, setAccessRoles] = useState([])



    const dateChangeHandler = (date) => {
        setUserConfigData({
            ...userConfigData,
            expiryDate: date
        })
    };

    const accountTypeChangeHandler = (value) => {
        if (value?.typecode === configJSON.ACCOUNTTYPE_FREETRIAL) {
            let accessRoleInfo = accessRoles.find(role => role.accesscode === configJSON.USAGE_ROLE_USER)
            setUserConfigData({
                ...userConfigData,
                accountType: value,
                chatLimit: configJSON.DEFAULT_CHAT_LIMIT,
                expiryDate: new Date(new Date().setDate(new Date().getDate() + 30)),
                accessRoleData: accessRoleInfo,
                usageAccess: ["Create JD", "Check Usage", "Access Chat history"]
            });

        }
        else {
            setUserConfigData({
                ...userConfigData,
                accountType: value,
            })
        }

    }

    const handleUsageAccessChange = (value) => {
        setUserConfigData({
            ...userConfigData,
            usageAccess: value
        })
    }

    const handleAccessRolesChange = (value) => {
        if (value) {
            if (value.accesscode === "ADMIN") {
                setUserConfigData({
                    ...userConfigData,
                    accessRoleData: value,
                    usageAccess: ["Create JD", "Check Usage", "Manage Users", "Approve Request", "Access Chat history"]
                })
            }
            else {
                setUserConfigData({
                    ...userConfigData,
                    accessRoleData: value,
                    usageAccess: ["Create JD", "Check Usage", "Access Chat history"]
                })
            }
        }
    }

    const clearData = () => {
        setUserConfigData({
            ...userConfigData,
            accountType: '',
            chatLimit: '',
            accessRoleData: {},
            expiryDate: new Date(),
            usageAccess: [],
        })
    }

    const handleSave = async () => {
        setIsDataUpdating(true)
        let payload = {
            accountType: userConfigData.accountType,
            chatLimit: userConfigData.chatLimit,
            expiryDate: new Date(userConfigData.expiryDate).toISOString(),
            roleAccessCode: userConfigData.accessRoleData.accesscode,
            permissions: {
                createJd: userConfigData.usageAccess.includes("Create JD"),
                checkUsage: userConfigData.usageAccess.includes("Check Usage"),
                manageUsers: userConfigData.usageAccess.includes("Manage Users"),
                approveRequest: userConfigData.usageAccess.includes("Approve Request"),
                accessChatHistory: userConfigData.usageAccess.includes("Access Chat history"),
            },
            approvedBy: userDetails?._id,
            isApproval: isUndoRejection ? true : isEdit ? false : true,
        }
        try {
            let response = await EditUserConfiguration(userData._id, payload)
            if (response.status === 200) {
                setKendoDataLoading(true)
                if (isUndoRejection) {
                    showToast("User Approved !!", "success");
                }
                else {
                    if (isEdit)
                        showToast("User Updated !!", "success");
                    else
                        showToast("User Approved !!", "success");
                }
                setIsDataUpdating(false)

                handleClose();
                clearData();
                if (isUndoRejection) {
                    handleRevokeUserRowChange(userData)
                }
                else {
                    if (!isEdit)
                        pendingRowAdjustment(userData)
                    else {
                        payload["roleAccessId"] = userConfigData.accessRoleData._id
                        handleApprovedUserRowChange(userData, payload)
                    }
                }
            }
        } catch (error) {
            console.log("error", error)
            showToast("Error while updating data", "error");
        }
    }

    const fetchRequiredDetails = async () => {
        try {
            const [responseAccountType, responseAccessRoles] = await Promise.all([
                GetAllAccountTypeData(),
                getAccessRoles()
            ]);

            setAccountTypeData(responseAccountType.data);
            setAccessRoles(responseAccessRoles.data);

            const permissionKeys = [
                { key: "createJd", label: "Create JD" },
                { key: "checkUsage", label: "Check Usage" },
                { key: "manageUsers", label: "Manage Users" },
                { key: "approveRequest", label: "Approve Request" },
                { key: "accessChatHistory", label: "Access Chat history" }
            ];

            const permissionsArray = permissionKeys
                .filter(({ key }) => userData?.accountConfig?.permissions?.[key])
                .map(({ label }) => label);

            const usageAccessRole = responseAccessRoles.data.find(role =>
                role._id.toString() === userData?.accountConfig?.roleAccessId.toString()
            );

            setUserConfigData(prevConfig => ({
                ...prevConfig,
                accountType: userData?.accountTypeInfo,
                chatLimit: userData?.accountConfig?.chatLimit,
                expiryDate: userData?.accountConfig?.contractEndDate ? new Date(userData?.accountConfig?.contractEndDate) : null,
                accessRoleData: usageAccessRole,
                usageAccess: permissionsArray,
            }));
            setIsDataLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            showToast("Error while fetching data", "error");
        }
    };

    useEffect(() => {
        if (open) {
            fetchRequiredDetails()
        }
    }, [open])

    return (
        <Dialog
            open={open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth='md'
            fullWidth
        >
            <DialogTitle className='dialogTitle_manageUsers'>
                <div className='headerSection_manageUsers'>
                    {isUndoRejection ? <span>Undo Revoke and approve</span> : isEdit ? <span>Edit User</span> : <span>Approve User</span>}
                    <IconButton onClick={() => handleClose()}>
                        <Close className='closeButton_usageModal' />
                    </IconButton>
                </div>
            </DialogTitle>
            <DialogContent>
                {isDataLoading ? <div className='loadingContainer_manageUsers'>
                    <CircularProgress />
                </div> :
                    <div className='dialogContent_manageUsers'>
                        <div className='inputContainer_manageUsers'>
                            <span>Account Type*</span>
                            <Autocomplete
                                className='autocomplete_signup'
                                filterSelectedOptions
                                options={accountTypeData}
                                getOptionLabel={(option) => option?.typename}
                                value={userConfigData.accountType}
                                onChange={(e, value) => accountTypeChangeHandler(value)}
                                renderInput={(params) => <TextField placeholder='Select account type...' {...params} />}
                            />
                        </div>
                        <div className='inputContainer_manageUsers'>
                            <span>Chat Limit*</span>
                            <TextField
                                className='textField_signup'
                                placeholder='Enter chat limit'
                                type='number'
                                value={userConfigData?.chatLimit || ''}
                                onChange={(e) => setUserConfigData({ ...userConfigData, chatLimit: e.target.value })}
                                disabled={userConfigData?.accountType?.typecode === configJSON.ACCOUNTTYPE_FREETRIAL}
                            />
                        </div>
                        <div className='inputContainer_manageUsers datePickerContainer_manageUsers'>
                            <span>Account Expiry Date*</span>
                            <DatePicker
                                className="datePicker_manageUsers"
                                selected={userConfigData.expiryDate}
                                onChange={(date) => dateChangeHandler(date)}
                                dateFormat="dd - MMM - yyyy"
                                showIcon
                                minDate={new Date()}
                                placeholderText='DD - MMM - YYYY'
                            />
                        </div>
                        <div className='inputContainer_manageUsers'>
                            <span>Usage Role*</span>
                            <Autocomplete
                                className='autocomplete_signup'
                                options={accessRoles}
                                filterSelectedOptions
                                getOptionLabel={(option) => option?.accessName}
                                value={userConfigData?.accessRoleData || null}
                                onChange={(e, value) => handleAccessRolesChange(value)}
                                renderInput={(params) => <TextField placeholder='Select account type...' {...params} />}
                                disabled={userConfigData?.accountType?.typecode === configJSON.ACCOUNTTYPE_FREETRIAL}
                            />
                        </div>
                        <div className='inputContainer_manageUsers'>
                            <span>Permissions*</span>
                            <Autocomplete
                                multiple
                                className='autocomplete_manageUsers'
                                id="checkboxes-tags-demo"
                                options={userConfigData.accessRoleData?.accesscode === "ADMIN" ? usageAccessOptions_admin : usageAccessOptions_user}
                                disableCloseOnSelect
                                getOptionLabel={(option) => option}
                                disabled={userConfigData.accessRoleData?.accesscode === "ADMIN" ? true : false}
                                onChange={(e, value) => handleUsageAccessChange(value)}
                                renderOption={(props, option, { selected }) => {
                                    const { key, ...optionProps } = props;
                                    return (
                                        <li key={key} {...optionProps}>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                            />
                                            {option}
                                        </li>
                                    );
                                }}
                                value={userConfigData.usageAccess}
                                style={{ width: 500 }}
                                renderInput={(params) => (
                                    <TextField {...params} placeholder="Manage access" />
                                )}
                            />
                        </div>
                    </div>
                }
            </DialogContent>
            <DialogActions className='dialogActions_manageUsers'>
                <button className='savebutton_manageUsers' onClick={() => handleSave()} disabled={isDataUpdating || isDataLoading}>
                    {isDataUpdating ? <CircularProgress size={20} className='cp_button' /> : null}
                    <span>{isDataUpdating ? "Please wait..." : (isUndoRejection || !isEdit) ? "Approve" : "Save"}</span>
                </button>
                <button className='closebutton_manageUsers' onClick={() => handleClose()} disabled={isDataUpdating || isDataLoading}>Cancel</button>
            </DialogActions>
        </Dialog>
    )
}

export default ApprovalDialogBox